<template>
    <div>
        <div class="card-item">
            <a :href="`${baseUrl}${this.company.name}/${this.company.id}/`">
                <div class="logo-container">
                    <object :data="company.logo" type="image/png" :alt="company.name">
                        <img src="/wp-content/themes/kwankotheme/assets/images/program_directory/program_default.svg"
                             :alt="company.name">
                    </object>
                    <object
                            class="geo"
                            :key="country"
                            :alt="country"
                            :title="country"
                            :data="`/wp-content/themes/kwankotheme/assets/images/flags/${ country.toLowerCase() }.svg`"
                            type="image/svg+xml"
                    >
                        <img src="/wp-content/themes/kwankotheme/assets/images/flags/world.svg" :alt="country">
                    </object>
                </div>
            </a>
            <div class="company-info">
                <a :href="`${baseUrl}${this.company.name}/${this.company.id}/`">
                    <h4>
                        {{ company.name }}
                    </h4>
                </a>
            </div>
            <div class="categories" v-if="campaignCategories">
                <span v-for="category in campaignCategories" :key="category">{{ category }}</span>
            </div>

            <p v-html="descriptionHandler "></p>
            <div class="commission" v-if="company.payout_types">
                <h5>Commission: </h5>
                <div v-for="payout in payouts" :key="payout.icon" class="payout">
                    <img :src="`/wp-content/themes/kwankotheme/assets/images/program_directory/${payout.icon}.svg`"
                         :alt="payout.icon">
                    <span> {{ payout.text }}</span>
                </div>
            </div>
            <div class="commission" v-else>
                <h5>Commission: </h5>
                <span>View details</span>
            </div>

            <a class="btn btn-lg btn-block btn-cta btn-main"
               :href="`${baseUrl}${this.company.name}/${this.company.id}/`">
                {{ moreInfo }}
                <img class="cta-arrow lazy"
                    src="/wp-content/themes/kwankotheme/assets/images/icons/white_arrow.svg"
                    style=""
                >
            </a>

        </div>
    </div>
</template>

<script>
export default {
    name: 'CardComponent',
    props: {
        company: Object,
        categories: Array,
        moreInfo: String,
        baseUrl: String,
    },
    computed: {
        descriptionHandler() {
            if (this.company.description) {
                return `${this.company.description.slice(0, 130)}…`;
            }
            return '';
        },
        country() {
            if (this.company.countries && this.company.countries.length && this.company.countries.length <= 1) {
                return this.company.countries[0];
            }
            return '';
        },
        payouts() {
            const payoutInfo = [];
            let sufix = this.company.currency;
            this.company.payout_types.forEach((payout) => {
                for (const [key, payoutType] of Object.entries(this.company.payout_ranges[payout])) {
                    let min = Number(payoutType.min).toFixed(2);
                    let max = Number(payoutType.max).toFixed(2);
                    if (key === 'percent') {
                        sufix = '%';
                        min = Number(payoutType.min).toFixed(0);
                        max = Number(payoutType.max).toFixed(0);
                    }

                    let text = `${min} ${sufix}`;
                    if (min !== max) {
                        text += ` up to ${max} ${sufix}`;
                    }
                    payoutInfo.push({
                        icon: payout,
                        text,
                    });
                }
            });

            return payoutInfo;
        },
        campaignCategories() {
            const categories = [];
            this.company.iab_categories.forEach((id) => {
                this.categories.filter(
                    // eslint-disable-next-line array-callback-return
                    (element) => {
                        if (element.id === parseInt(id, 10)) {
                            categories.push(element.label);
                        }
                    },
                );
            });
            return categories;
        },
    },
};
</script>
